import React from "react";
import { string } from "prop-types";
import { DATA_SPACER } from "#library/constants/enums";
import { Text, TEXT_TYPES, TEXT_COLORS } from "#library/components/Text/Text";
export var ModalTopHeaderText = function ModalTopHeaderText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Text, {
    type: TEXT_TYPES.SMALL,
    color: TEXT_COLORS.GREY,
    resetSpacing: true,
    dataSpacer: DATA_SPACER.BOTTOM_100
  }, children);
};
ModalTopHeaderText.propTypes = {
  children: string.isRequired
};